import * as React from 'react';
import { Label } from '../../../../../web/components-v2/Label';
import { RadioGroupItem } from '../../../../../web/components-v2/RadioGroup';
import { TurnItOnForOptions } from '../../../../viewModels/leadrules';

interface IProps {
	label: string;
	value: TurnItOnForOptions;
}

export const OptionRadio: React.FC<IProps> = ({ label, value }) => (
	<Label htmlFor={`turn-it-on-for-${value}`}>
		<RadioGroupItem id={`turn-it-on-for-${value}`} value={value} />
		{label}
	</Label>
);
